import api from './api'
import { format } from 'date-fns'

export const downloadNfesFornecedor = async (id, dateOf, dateUntil) => {
    const dataDe = format(dateOf, 'yyyy-MM-dd')
    const dataAte = format(dateUntil, 'yyyy-MM-dd')
    return await api.get('/api/entradamercadoria/download',
        {
            responseType: 'blob',
            params: { dataDe, dataAte },
            headers: { 'X-TenantId': id }
        })
}

export const getNfesFornecedor = async (id, dateOf, dateUntil, page) => {
    const dataDe = format(dateOf, 'yyyy-MM-dd')
    const dataAte = format(dateUntil, 'yyyy-MM-dd')
    return await api.get('/api/entradamercadoria',
        {
            params: { dataDe, dataAte, page },
            headers: { 'X-TenantId': id }
        })
}